import { call, put, takeLatest } from 'redux-saga/effects';

import * as featureActions from './featureActions.js';
import { updateFeatureApiCall } from './featureAPI.js';

function* updateFeatureSaga({ payload }) {
  try {
    const { data } = yield call(updateFeatureApiCall, payload);
    yield put(featureActions.featureUpdateStore(data));
  } catch (error) {
    yield put(featureActions.featureUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* featureWatcher() {
  yield takeLatest(featureActions.featureUpdateRequest.type, updateFeatureSaga);
}
